<template>
    <aside class="panel-detalle" :class="{ 'visible': itemSeleccionado || modoAccion }">
        <!-- Vista Perfil del Paciente -->
        <div v-if="modoAccion === 'perfil-paciente'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-user-circle icono-header-simple"></i> Datos del Paciente</h3>
                <div class="header-buttons">
                    <ArgonButton
:color="isEditing ? 'success' : 'info'" size="sm" variant="gradient"
                        @click="toggleEditMode">
                        <i :class="isEditing ? 'fas fa-check' : 'fas fa-edit'"></i>
                        {{ isEditing ? 'Guardar' : 'Editar' }}
                    </ArgonButton>
                    <ArgonButton
v-if="isEditing" color="secondary" size="sm" variant="gradient"
                        @click="cancelarEdicion">
                        <i class="fas fa-times"></i>
                        Cancelar
                    </ArgonButton>
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <div class="perfil-container">
                    <PatientAvatar
:photo-url="patientPhotoUrl"
                        :full-name="datosPaciente.first_name + ' ' + datosPaciente.last_name"
                        :has-photo="Boolean(datosPaciente.photo_url)" :on-update-photo="updatePatientPhoto"
                        :on-delete-photo="deletePatientPhoto" />
                    <div class="perfil-info">
                        <PersonalInformation
:is-editing="isEditing" :perfil-editado="perfilEditado"
                            :datos-paciente="datosPaciente" :email-invalido="emailInvalido" :email-tocado="emailTocado"
                            :formatear-fecha-nacimiento="formatearFechaNacimiento" :formatear-genero="formatearGenero"
                            :on-email-input="onEmailInput" :on-email-blur="handleEmailBlur" />
                        <ContactInformation
:is-editing="isEditing" :perfil-editado="perfilEditado"
                            :perfil-paciente="perfilPaciente" />
                        <EmergencyContact
:is-editing="isEditing" :perfil-editado="perfilEditado"
                            :perfil-paciente="perfilPaciente" />
                        <PatientComments
:is-editing="isEditing" :perfil-editado="perfilEditado"
                            :perfil-paciente="perfilPaciente" />
                        <div v-if="perfilPaciente.updated_at" class="ultima-actualizacion">
                            <i class="fas fa-clock"></i>
                            <span>Última actualización: {{ formatearFecha(perfilPaciente.updated_at) }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Vista Expediente Completo -->
        <div v-else-if="modoAccion === 'expediente-completo'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-folder-open"></i> Expediente Completo</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <p class="descripcion-modo">Vista consolidada del expediente médico completo del paciente.</p>
                <div class="expediente-secciones">
                    <div class="seccion-expediente">
                        <div class="seccion-header">
                            <i class="fas fa-file-medical"></i>
                            <h4>Notas Médicas</h4>
                            <span class="contador">45</span>
                        </div>
                        <p>Consultas y evoluciones clínicas</p>
                    </div>
                    <div class="seccion-expediente">
                        <div class="seccion-header">
                            <i class="fas fa-prescription"></i>
                            <h4>Recetas</h4>
                            <span class="contador">28</span>
                        </div>
                        <p>Prescripciones médicas activas e históricas</p>
                    </div>
                    <div class="seccion-expediente">
                        <div class="seccion-header">
                            <i class="fas fa-file-alt"></i>
                            <h4>Documentos</h4>
                            <span class="contador">12</span>
                        </div>
                        <p>Estudios, laboratorios e imágenes</p>
                    </div>
                    <div class="seccion-expediente">
                        <div class="seccion-header">
                            <i class="fas fa-heart-pulse"></i>
                            <h4>Signos Vitales</h4>
                            <span class="contador">156</span>
                        </div>
                        <p>Registro histórico de signos vitales</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Vista Documentos -->
        <div v-else-if="modoAccion === 'documentos'" class="panel-content">
            <div class="panel-body documentos-panel">
                <div v-if="!patientId" class="no-patient-message">
                    <i class="fas fa-exclamation-triangle"></i>
                    <p>No se ha seleccionado un paciente</p>
                </div>
                <FilesManager v-else :patient-id="patientId" @error="handleDocumentError" />
            </div>
        </div>

        <!-- Vista Historia Clínica Completa -->
        <div v-else-if="modoAccion === 'historia-clinica'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-file-medical-alt"></i> Historia Clínica Completa</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <div class="historia-container">
                    <div class="historia-avatar">
                        <i class="fas fa-file-medical-alt fa-5x"></i>
                    </div>
                    <div class="historia-info">
                        <h2>Historia Clínica del Paciente</h2>
                        <div class="info-grid">
                            <div class="info-item">
                                <i class="fas fa-user-injured"></i>
                                <div>
                                    <label>Antecedentes Personales</label>
                                    <p>Diabetes tipo 2, Hipertensión arterial</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <i class="fas fa-dna"></i>
                                <div>
                                    <label>Antecedentes Familiares</label>
                                    <p>Padre: Diabetes, Madre: Hipertensión</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <i class="fas fa-allergies"></i>
                                <div>
                                    <label>Alergias Registradas</label>
                                    <p>Penicilina, Mariscos</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <i class="fas fa-pills"></i>
                                <div>
                                    <label>Medicamentos Actuales</label>
                                    <p>Metformina 850mg, Losartán 50mg</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <i class="fas fa-procedures"></i>
                                <div>
                                    <label>Cirugías Previas</label>
                                    <p>Apendicectomía (2015)</p>
                                </div>
                            </div>
                            <div class="info-item">
                                <i class="fas fa-heartbeat"></i>
                                <div>
                                    <label>Enfermedades Crónicas</label>
                                    <p>Diabetes Mellitus tipo 2, Hipertensión</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Vista Alertas del Paciente -->
        <div v-else-if="modoAccion === 'alertas-paciente'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-bell"></i> Alertas del Paciente</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <!-- Componente de Alertas Integrado -->
                <PatientAlerts v-if="patientId" :patient-id="patientId" />
            </div>
        </div>

        <!-- Vista según modo de acción -->
        <div v-else-if="modoAccion === 'ver-historial'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-list-timeline"></i> Historial Completo</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <!-- Componente de historial completo con filtros avanzados aplicados -->
                <PatientTimeline
v-if="datosPaciente && datosPaciente.id" :patient-id="datosPaciente.id"
                    :filtro-avanzado="filtroAvanzado" />
            </div>
        </div>

        <!-- Nueva Nota Médica (usando MedicalNoteForm.vue) -->
        <div v-else-if="modoAccion === 'nueva-nota' || modoAccion === 'editar-nota'" class="panel-content">
            <div class="panel-body no-header">
                <NoteForm
:notes="filteredNotes"
                    :current-id="modoAccion === 'editar-nota' && datosEdicion ? datosEdicion.id : currentId"
                    :select-note="selectNote" :errors="errors" :patient-record="datosPaciente" :note-form="noteForm"
                    :active-tab-prefix="activeTabPrefixLocal" @save-note="saveNote" @reset-form="resetForm"
                    @delete-note="deleteNote" @update:active-tab="activeTab = $event"
                    @clear-field-error="clearFieldError" @clear-all-errors="clearAllErrors" />
            </div>
        </div>

        <!-- Nueva Receta -->
        <div v-else-if="modoAccion === 'nueva-receta' || modoAccion === 'editar-receta'" class="panel-content">
            <div class="panel-body no-header">
                <PrescriptionForm
:notes="filteredPrescriptions" :current-id="currentId"
                    :select-note="selectPrescription" :errors="errors" :patient-record="datosPaciente"
                    :note-form="noteForm" :active-tab-prefix="'prescription'" @save-note="savePrescription"
                    @reset-form="resetForm" @delete-note="deletePrescription" @update:active-tab="activeTab = $event"
                    @clear-field-error="clearFieldError" @clear-all-errors="clearAllErrors" />
            </div>
        </div>

        <!-- Nuevo Examen Físico -->
        <div v-else-if="modoAccion === 'nuevo-examen'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-stethoscope"></i> Nuevo Examen Físico</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <form class="formulario-examen">
                    <div class="form-group">
                        <label>Fecha del Examen</label>
                        <input type="datetime-local" class="form-control" />
                    </div>
                    <div class="signos-vitales-grid">
                        <div class="form-group">
                            <label>Presión Arterial</label>
                            <input type="text" class="form-control" placeholder="120/80 mmHg" />
                        </div>
                        <div class="form-group">
                            <label>Frecuencia Cardíaca</label>
                            <input type="number" class="form-control" placeholder="75 lpm" />
                        </div>
                        <div class="form-group">
                            <label>Temperatura</label>
                            <input type="number" step="0.1" class="form-control" placeholder="36.5 °C" />
                        </div>
                        <div class="form-group">
                            <label>Frecuencia Respiratoria</label>
                            <input type="number" class="form-control" placeholder="16 rpm" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Observaciones Generales</label>
                        <textarea rows="4" class="form-control" placeholder="Estado general del paciente..."></textarea>
                    </div>
                    <div class="form-group">
                        <label>Hallazgos Específicos</label>
                        <textarea rows="5" class="form-control" placeholder="Detalles del examen físico..."></textarea>
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn-guardar">
                            <i class="fas fa-save"></i> Guardar Examen
                        </button>
                        <button type="button" class="btn-cancelar" @click="cerrarPanel">
                            <i class="fas fa-times"></i> Cancelar
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- Nuevo Reporte con Imágenes / Documentos -->
        <!-- Nuevo Documento / Reporte -->
        <div v-else-if="modoAccion === 'nuevo-reporte' || modoAccion === 'editar-documento'" class="panel-content">
            <div class="panel-body no-header">
                <DocumentsForm
:notes="filteredDocuments" :current-id="currentId" :select-note="selectDocument"
                    :errors="errors" :patient-record="datosPaciente" :note-form="noteForm"
                    :active-tab-prefix="'document'" @save-note="saveDocument" @reset-form="resetForm"
                    @delete-note="deleteDocument" @update:active-tab="activeTab = $event"
                    @clear-field-error="clearFieldError" @clear-all-errors="clearAllErrors" />
            </div>
        </div>

        <!-- Gráficos -->
        <div v-else-if="modoAccion === 'signos-vitales'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-heart-pulse"></i> Gráficas</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <div v-if="showPediatricCharts">
                    <GraficasPediatria v-if="patientId" :patient-id="patientId" class="pediatric-graphs" />
                    <div v-else class="empty-state">
                        <i class="fas fa-user-slash"></i>
                        <p>No se ha seleccionado un paciente</p>
                    </div>
                </div>
                <template v-else>
                    <div v-if="loadingVitalSigns" class="loading-state">
                        <i class="fas fa-spinner fa-spin fa-2x"></i>
                        <p>Cargando datos...</p>
                    </div>
                    <div v-else-if="hasNoVitalSigns" class="empty-state">
                        <i class="fas fa-chart-line fa-3x"></i>
                        <h4>No hay datos de signos vitales</h4>
                        <p>Aún no se han registrado signos vitales para este paciente.</p>
                        <p class="text-muted">Los datos se registrarán automáticamente al crear notas médicas con
                            exploración
                            física.</p>
                    </div>
                    <div v-else>
                        <VitalSignsChart
:weight-data="vitalSignsData.weight" :height-data="vitalSignsData.height"
                            :bmi-data="vitalSignsData.bmi" />
                    </div>
                </template>
            </div>
        </div>

        <!-- Gestionar Alergias -->
        <div v-else-if="modoAccion === 'alergias'" class="panel-content">
            <div class="panel-header">
                <h3><i class="fas fa-triangle-exclamation"></i> Gestión de Alergias</h3>
                <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
            </div>
            <div class="panel-body">
                <PatientAllergies v-if="patientId" :patient-id="patientId" />
                <div v-else class="empty-state">
                    <i class="fas fa-user-slash"></i>
                    <p>No se ha seleccionado un paciente</p>
                </div>
            </div>
        </div>

        <!-- Datos del Paciente (AG Grid) -->
        <div v-else-if="modoAccion === 'datos-paciente'" class="panel-content">
            <div class="panel-body no-header">
                <PatientDataGrid v-if="patientId" :patient-id="patientId" />
                <div v-else class="empty-state">
                    <i class="fas fa-user-slash"></i>
                    <p>No se ha seleccionado un paciente</p>
                </div>
            </div>
        </div>

        <!-- Vista de detalle normal cuando se selecciona un item -->
        <div v-else-if="itemSeleccionado" class="panel-content">
            <div class="panel-header">
                <h3>Detalle del Evento</h3>
                <div class="header-buttons">
                    <button class="cerrar-btn" @click="cerrarPanel">&times;</button>
                </div>
            </div>
            <div class="panel-body">
                <p><strong>Tipo:</strong> {{ itemSeleccionado.tipo }}</p>
                <p><strong>ID:</strong> {{ itemSeleccionado.id }}</p>
                <p>Aquí se cargaría el formulario o la vista detallada del elemento seleccionado desde la línea de
                    tiempo.</p>

                <!-- Ejemplo de formulario de edición -->
                <form class="detalle-form">
                    <div class="form-group">
                        <label for="detalle-texto">Contenido:</label>
                        <textarea
id="detalle-texto" rows="10"
                            :value="`Cargando contenido del evento ${itemSeleccionado.id}...`"></textarea>
                    </div>
                    <button type="submit">Guardar Cambios</button>
                </form>
            </div>
        </div>

        <!-- Vista vacía -->
        <div v-else class="panel-vacio">
            <i class="fas fa-hand-pointer"></i>
            <p>Seleccione un elemento de la historia clínica para ver sus detalles o use los botones superiores para
                crear uno nuevo.</p>
        </div>
    </aside>
</template>

<script setup>
import { defineProps, defineEmits, ref, computed, watch, onMounted, onUnmounted, nextTick, getCurrentInstance } from 'vue';
import { useStore as useVuexStore } from 'vuex';
// ✅ Import absoluto corregido
import { useMedicalWorkspace } from '@/composables/useMedicalWorkspace';
import { patientEventBus, updatePatientData } from '@/utils/eventBus.js';
import ArgonButton from '@/components/ArgonButton.vue';
import api from '@/services/api';
import { getFullFormatDate } from '@/utils/globalFunctions.js';
import { useStore as usePacientesStore } from '@/store/Expedientes/pacientes.js';
import profilePicture from '@/assets/img/profile-picture.png';
import profilePictureWomen from '@/assets/img/profile-picture-women.png';
// ✅ Import actualizado al componente renombrado
import NoteForm from '../Forms/MedicalNoteForm.vue';
import PrescriptionForm from '../Forms/PrescriptionForm.vue';
import DocumentsForm from '../Forms/DocumentsForm.vue';
import PatientTimeline from '../Timeline/PatientTimeline.vue';
import PersonalInformation from './PersonalInformation.vue';
import ContactInformation from './ContactInformation.vue';
import EmergencyContact from './EmergencyContact.vue';
import PatientComments from './PatientComments.vue';
import PatientAvatar from './PatientAvatar.vue';
import PatientAlerts from '@/components/PatientAlerts.vue';
import PatientAllergies from '@/components/PatientAllergies.vue';
import PatientDataGrid from '../Panels/PatientDataGrid.vue';
import VitalSignsChart from '@/components/Charts/VitalSignsChart.vue';
import GraficasPediatria from '../Forms/ClinicalHistory/GraficasPediatria.vue';
import FilesManager from '@/components/FileManager/FilesManager.vue';
// NO usar useNotes - en proceso de migración a useNoteFormGlobal
// import { useNotes } from '@/composables/useNotes';
import Swal from 'sweetalert2';

defineProps({
    itemSeleccionado: {
        type: Object,
        default: null
    },
    isExpanded: {
        type: Boolean,
        default: false
    }
});

// Validación de email
const emailInvalido = ref(false);
const emailTocado = ref(false);
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
const onEmailInput = () => {
    try {
        const valor = (perfilEditado.value?.email || '').trim();
        emailInvalido.value = valor.length > 0 && !emailRegex.test(valor);
    } catch (e) {
        emailInvalido.value = false;
    }
};
const handleEmailBlur = () => {
    emailTocado.value = true;
    onEmailInput();
};

const emit = defineEmits(['cerrar']);

const { proxy } = getCurrentInstance();

// Usar el store de Expedientes para actualizar localStorage
const { addPatientData } = usePacientesStore();

// Usuario autenticado para validar especialidades médicas
const vuexStore = useVuexStore();
const authenticatedUser = computed(() => vuexStore.state.auth.user);
const hasSpecialty = (specialtyId) => {
    const currentUser = authenticatedUser.value;
    if (!currentUser?.doctor?.specialties) {
        return false;
    }
    return currentUser.doctor.specialties.some((specialty) => specialty.id === specialtyId);
};
const showPediatricCharts = computed(() => hasSpecialty(3));

// Usar el composable para acceder a los métodos globales y al estado de modo de acción
const {
    cerrarDetalle,
    modoAccion,
    cerrarModoAccion,
    datosPaciente,
    patientId,
    cargarPacienteDesdeStore,
    datosEdicion,
    filtroAvanzado,
    activarModoAccion,
    cargarDatosEnFormulario
} = useMedicalWorkspace();

// Variable para manejar la suscripción del Event Bus
let eventBusUnsubscribe = null;
// Flag para prevenir bucles infinitos de actualizaciones
const isUpdatingFromEventBus = ref(false);

// Estados locales para el perfil del paciente
const isEditing = ref(false);
const perfilEditado = ref({
    // Datos básicos del paciente
    first_name: '',
    last_name: '',
    gender: '',
    birthdate: '',
    email: '',
    whatsapp: '',
    // Datos del perfil extendido
    address: '',
    reference: '',
    responsible_family_member: '',
    family_member_relationship: '',
    emergency_contact: '',
    patient_identification: '',
    internal_comments: '',
    patient_feedback: ''
});

// Computed para obtener el perfil del paciente actual
const perfilPaciente = computed(() => {
    return datosPaciente.value.profile || {};
});

// Computed para verificar si hay datos de signos vitales
const hasNoVitalSigns = computed(() => {
    return vitalSignsData.value.weight.data.length === 0 &&
        vitalSignsData.value.height.data.length === 0 &&
        vitalSignsData.value.bmi.data.length === 0;
});

// Funciones para formatear datos
const formatearFechaNacimiento = () => {
    const fecha = datosPaciente.value.birthdate;
    if (!fecha) return 'No especificado';

    // Parsear la fecha ISO correctamente para evitar problemas con timezone
    const [year, month, day] = fecha.split('-').map(Number);
    const fechaObj = new Date(year, month - 1, day);

    const hoy = new Date();
    let edad = hoy.getFullYear() - fechaObj.getFullYear();
    const mesActual = hoy.getMonth();
    const diaActual = hoy.getDate();
    const mesNacimiento = fechaObj.getMonth();
    const diaNacimiento = fechaObj.getDate();

    // Ajustar la edad si no ha pasado el cumpleaños este año
    if (mesActual < mesNacimiento || (mesActual === mesNacimiento && diaActual < diaNacimiento)) {
        edad--;
    }

    return `${fechaObj.toLocaleDateString('es-ES')} (${edad} años)`;
};


const formatearGenero = () => {
    const genero = datosPaciente.value.gender;
    if (!genero) return 'No especificado';

    const generos = {
        'M': 'Masculino',
        'F': 'Femenino',
        'O': 'Otro',
        'male': 'Masculino',
        'female': 'Femenino',
        'other': 'Otro'
    };

    return generos[genero] || genero;
};

// Función para obtener la foto de perfil según el género
const getProfilePicture = (gender) => {
    return (gender === 'F' || gender === 'female') ? profilePictureWomen : profilePicture;
};

// Computed para la URL de la foto del paciente
const patientPhotoUrl = computed(() => {
    return datosPaciente.value?.photo_url || getProfilePicture(datosPaciente.value?.gender);
});

// Función para subir foto del paciente
const updatePatientPhoto = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validar tipo de archivo
    if (!file.type.startsWith('image/')) {
        proxy.$notify("Por favor selecciona una imagen válida.", "", "warning", "ni ni-alert-circle-exc ni-lg");
        return;
    }

    // Validar tamaño (máx 5MB)
    if (file.size > 5 * 1024 * 1024) {
        proxy.$notify("La imagen no debe superar 5MB.", "", "warning", "ni ni-alert-circle-exc ni-lg");
        return;
    }

    const formData = new FormData();
    formData.append('photo', file);

    try {
        const response = await api.post(`/pacientes/${patientId.value}/photo`, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });

        console.log('📸 Respuesta del servidor:', response.data);

        // Actualizar foto del paciente en datosPaciente
        const updatedData = response.data.data;
        console.log('📸 Datos actualizados:', updatedData);
        console.log('📸 datosPaciente ANTES:', datosPaciente.value.photo_url);

        // ⚡ IMPORTANTE: Como datosPaciente es shallowRef, debemos crear un nuevo objeto
        datosPaciente.value = {
            ...datosPaciente.value,
            photo_url: updatedData.photo_url,
            photo: updatedData.photo
        };

        console.log('📸 datosPaciente DESPUÉS:', datosPaciente.value.photo_url);

        // ✅ Actualizar el store de Expedientes para sincronizar con localStorage
        addPatientData({
            id: patientId.value,
            photo_url: updatedData.photo_url,
            photo: updatedData.photo
        });
        console.log('💾 Store de Expedientes actualizado con nueva foto');

        // ✅ Emitir evento global reutilizando updatePatientData para mantener sincronizada la data en todos los módulos
        console.log('📢 DetailsPanel: Emitiendo evento patient-photo-updated para paciente ID:', patientId.value);
        updatePatientData({
            ...datosPaciente.value,
            action: 'patient-photo-updated'
        });

        proxy.$notify(response.data.message, "", "success", "ni ni-like-2 ni-lg");

    } catch (error) {
        proxy.$notify(
            error.response?.data?.message || "Error al actualizar la foto.",
            "",
            "danger",
            "ni ni-fat-remove ni-lg"
        );
    }
};

// Función para eliminar foto del paciente
const deletePatientPhoto = async () => {
    if (!datosPaciente.value.photo_url) {
        proxy.$notify("No hay foto para eliminar.", "", "warning", "ni ni-alert-circle-exc ni-lg");
        return;
    }

    const result = await Swal.fire({
        title: '¿Estás seguro?',
        html: '¡No podrás revertir esto!<br>¿Deseas eliminar la foto del paciente?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, elimínala',
        customClass: {
            confirmButton: 'btn bg-gradient-success',
            cancelButton: 'btn bg-gradient-danger'
        },
        buttonsStyling: false
    });

    if (!result.isConfirmed) {
        return;
    }

    try {
        const response = await api.delete(`/pacientes/${patientId.value}/photo`);

        console.log('🗑️ Foto eliminada del servidor');
        console.log('🗑️ datosPaciente ANTES:', datosPaciente.value.photo_url);

        // ⚡ IMPORTANTE: Como datosPaciente es shallowRef, debemos crear un nuevo objeto
        datosPaciente.value = {
            ...datosPaciente.value,
            photo_url: null,
            photo: null
        };

        console.log('🗑️ datosPaciente DESPUÉS:', datosPaciente.value.photo_url);

        // ✅ Actualizar el store de Expedientes para sincronizar con localStorage
        addPatientData({
            id: patientId.value,
            photo_url: null,
            photo: null
        });
        console.log('💾 Store de Expedientes actualizado - foto eliminada');

        // ✅ Emitir evento global reutilizando updatePatientData para mantener sincronizada la data
        console.log('📢 DetailsPanel: Emitiendo evento patient-photo-deleted para paciente ID:', patientId.value);
        updatePatientData({
            ...datosPaciente.value,
            action: 'patient-photo-deleted'
        });

        proxy.$notify(response.data.message, "", "success", "ni ni-like-2 ni-lg");

    } catch (error) {
        proxy.$notify(
            error.response?.data?.message || "Error al eliminar la foto.",
            "",
            "danger",
            "ni ni-fat-remove ni-lg"
        );
    }
};

const formatearFecha = (fecha) => {
    if (!fecha) return '';
    return getFullFormatDate(fecha);
};

// --- Integración de NoteForm (Notas Médicas) dentro del panel ---
// MIGRADO: Ya no usar useNotes, gestión directa del estado
const activeTabPrefixLocal = 'panelDetalle_';
const resourceApiNotes = 'patient-medical-notes';
const resourceApiPrescriptions = 'patient-medical-prescriptions';
const resourceApiDocuments = 'patient-documents';

// Estado local para notas
const noteForm = ref({
    created: new Date().toISOString().split('T')[0],
    reason_for_visit: '',
    soap: '',
    physical_examination: '',
    laboratory_and_studies: '',
    diagnoses_clinical_problems: '',
    physical_examination_json: '{}',
    diagnosis_cie10_1: '',
    diagnosis_cie10_2: '',
    diagnosis_cie10_3: '',
});
const errors = ref({});
const filteredNotes = ref([]);
const filteredPrescriptions = ref([]);
const filteredDocuments = ref([]);
const activeTab = ref('create');
const currentId = ref(0);

// Variables para gráficas de signos vitales
const vitalSignsData = ref({
    weight: { labels: [], data: [], current: null },
    height: { labels: [], data: [], current: null },
    bmi: { labels: [], data: [], current: null }
});
const loadingVitalSigns = ref(false);

// Función para limpiar errores
const clearFieldError = (fieldName) => {
    if (errors.value[fieldName]) {
        delete errors.value[fieldName];
    }
};

const clearAllErrors = () => {
    errors.value = {};
};

// Función para cargar notas del paciente
const fetchNotes = async () => {
    if (!patientId.value) return;

    try {
        const response = await api.get(`/${resourceApiNotes}`, {
            params: {
                patient_id: patientId.value,
                per_page: 100
            }
        });
        filteredNotes.value = response.data.data || [];
    } catch (error) {
        console.error('Error al cargar notas:', error);
    }
};

const fetchPrescriptions = async () => {
    if (!patientId.value) return;

    try {
        const response = await api.get(`/${resourceApiPrescriptions}`, {
            params: {
                patient_id: patientId.value,
                per_page: 100
            }
        });
        filteredPrescriptions.value = response.data.data || [];
    } catch (error) {
        console.error('Error al cargar recetas:', error);
    }
};

const fetchDocuments = async () => {
    if (!patientId.value) return;

    try {
        const response = await api.get(`/${resourceApiDocuments}`, {
            params: {
                patient_id: patientId.value,
                per_page: 100
            }
        });
        filteredDocuments.value = response.data.data || [];
    } catch (error) {
        console.error('Error al cargar documentos:', error);
    }
};

// Función para cargar datos de signos vitales para gráficas
const fetchVitalSigns = async () => {
    if (!patientId.value) return;

    loadingVitalSigns.value = true;
    try {
        const response = await api.get(`/${resourceApiNotes}`, {
            params: {
                patient_id: patientId.value,
                per_page: 100,
                sort_column: 'created',
                sort_order: 'asc'
            }
        });

        const notes = response.data.data || [];

        const weightData = [];
        const heightData = [];
        const bmiData = [];
        const labels = [];

        // eslint-disable-next-line no-unused-vars
        notes.forEach((note, index) => {
            if (note.physical_examination_json) {
                try {
                    // Parsear JSON si viene como string
                    const physicalExam = typeof note.physical_examination_json === 'string'
                        ? JSON.parse(note.physical_examination_json)
                        : note.physical_examination_json;

                    const weight = physicalExam.weight;
                    const height = physicalExam.height;
                    const bmi = physicalExam.bmi;

                    // Solo procesar si hay al menos un dato
                    if (weight || height || bmi) {
                        // Formatear fecha para label
                        const fecha = new Date(note.created);
                        const label = fecha.toLocaleDateString('es-ES', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                        });
                        labels.push(label);

                        // Peso en kg (convertir a número)
                        if (weight) {
                            weightData.push(parseFloat(weight));
                        } else {
                            weightData.push(null);
                        }

                        // Altura en cm (convertir a número)
                        if (height) {
                            heightData.push(parseFloat(height));
                        } else {
                            heightData.push(null);
                        }

                        // IMC (calcular si no viene o usar el que viene)
                        if (bmi) {
                            bmiData.push(parseFloat(bmi));
                        } else if (weight && height) {
                            // Calcular IMC: peso(kg) / (altura(cm)/100)^2
                            const heightInMeters = parseFloat(height) / 100;
                            const calculatedBmi = parseFloat(weight) / (heightInMeters * heightInMeters);
                            bmiData.push(parseFloat(calculatedBmi.toFixed(2)));
                        } else {
                            bmiData.push(null);
                        }
                    }
                } catch (e) {
                    console.error('❌ Error parsing physical_examination_json:', e, note);
                }
            }
        });

        const weightEntries = [];
        labels.forEach((label, i) => {
            if (weightData[i] !== null) {
                weightEntries.push({ label, value: weightData[i] });
            }
        });

        const heightEntries = [];
        labels.forEach((label, i) => {
            if (heightData[i] !== null) {
                heightEntries.push({ label, value: heightData[i] });
            }
        });

        // IMC: filtrar entradas con IMC válido
        const bmiEntries = [];
        labels.forEach((label, i) => {
            if (bmiData[i] !== null) {
                bmiEntries.push({ label, value: bmiData[i] });
            }
        });

        // Actualizar datos de las gráficas con labels y datos sincronizados
        vitalSignsData.value = {
            weight: {
                labels: weightEntries.map(e => e.label),
                data: weightEntries.map(e => e.value),
                current: weightEntries.length > 0 ? weightEntries[weightEntries.length - 1].value.toFixed(2) : null
            },
            height: {
                labels: heightEntries.map(e => e.label),
                data: heightEntries.map(e => e.value),
                current: heightEntries.length > 0 ? heightEntries[heightEntries.length - 1].value.toFixed(2) : null
            },
            bmi: {
                labels: bmiEntries.map(e => e.label),
                data: bmiEntries.map(e => e.value),
                current: bmiEntries.length > 0 ? bmiEntries[bmiEntries.length - 1].value.toFixed(2) : null
            }
        };

    } catch (error) {
        console.error('❌ Error al cargar signos vitales:', error);
    } finally {
        loadingVitalSigns.value = false;
    }
};

// Función para guardar nota
const saveNote = async (note) => {
    try {
        if (!patientId.value) {
            Swal.fire("Error", "No se puede guardar la nota: paciente no identificado", "error");
            return;
        }

        // Asegurar que tenga patient_id
        note.patient_id = patientId.value;

        const response = note.id
            ? await api.put(`/${resourceApiNotes}/${note.id}`, note)
            : await api.post(`/${resourceApiNotes}`, note);

        const savedNote = response.data.data;

        // Limpiar errores después de guardar exitosamente
        errors.value = {};

        // Mostrar mensaje del backend
        proxy.$notify(response.data.message || "Nota guardada exitosamente", "", "success", "ni ni-like-2 ni-lg");

        // Refrescar la lista
        await fetchNotes();

        // ✅ Emitir evento para actualizar LineaHistoria automáticamente
        const currentPatientId = patientId.value;
        patientEventBus.notify(currentPatientId, { action: 'note-saved', noteId: savedNote.id });

        // Si es una nota nueva, actualizar el formulario con la nota guardada
        if (!note.id) {
            currentId.value = savedNote.id;
            noteForm.value = { ...savedNote };

            // ✅ Usar activarModoAccion para persistir el estado de edición
            activarModoAccion('editar-nota', 'Editar Nota', {
                editingState: {
                    currentId: savedNote.id,
                    resourceType: 'nota'
                }
            });

            // Cargar datos en el formulario (esto actualiza datosEdicion)
            cargarDatosEnFormulario(savedNote, 'nota-medica');

            // Mensaje de confirmación removido - el usuario decide cuándo crear otra nota
        }
    } catch (error) {
        console.error('❌ Error al guardar nota:', error.response?.data);
        if (error.response) {
            if (error.response.status === 422) {
                errors.value = error.response.data.errors || {};
                // Mostrar notificación de error
                const errorCount = Object.keys(errors.value).length;
                const firstError = Object.values(errors.value)[0];
                const errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;

                proxy.$notify(
                    `Error de validación: ${errorMessage}`,
                    `Se encontraron ${errorCount} error(es) en el formulario`,
                    "danger",
                    "ni ni-fat-remove ni-lg"
                );
            } else if (error.response.status === 403) {
                Swal.fire("Error", error.response.data.message, "error");
            } else {
                Swal.fire("Error", error.response.data.message || "Error al guardar", "error");
            }
        } else {
            Swal.fire("Error", "Error desconocido al guardar", "error");
        }
    }
};

// Función para eliminar nota
const deleteNote = async (note, fieldName) => {
    try {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            html: `¡No podrás revertir esto!<br>¿Deseas eliminar: <b>${note[fieldName]}</b>?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Sí, eliminar!',
            customClass: {
                confirmButton: 'btn bg-gradient-success',
                cancelButton: 'btn bg-gradient-danger'
            },
            buttonsStyling: false
        });

        if (result.isConfirmed) {
            await api.delete(`/${resourceApiNotes}/${note.id}`);
            Swal.fire('Eliminado!', 'La nota ha sido eliminada.', 'success');

            // Refrescar lista y resetear formulario
            await fetchNotes();
            resetForm();
        }
    } catch (error) {
        Swal.fire('Error', 'Hubo un problema al eliminar la nota.', 'error');
    }
};

// ========== FUNCIONES PARA RECETAS ==========
// Función para guardar receta (similar a saveNote)
const savePrescription = async (prescription) => {
    try {
        if (!patientId.value) {
            Swal.fire("Error", "No se puede guardar la receta: paciente no identificado", "error");
            return;
        }

        prescription.patient_id = patientId.value;

        const response = prescription.id
            ? await api.put(`/${resourceApiPrescriptions}/${prescription.id}`, prescription)
            : await api.post(`/${resourceApiPrescriptions}`, prescription);

        const savedPrescription = response.data.data;
        errors.value = {};

        proxy.$notify(response.data.message || "Receta guardada exitosamente", "", "success", "ni ni-like-2 ni-lg");

        // Refrescar la lista de recetas
        await fetchPrescriptions();

        // Actualizar timeline
        const currentPatientId = patientId.value;
        patientEventBus.notify(currentPatientId, { action: 'prescription-saved', prescriptionId: savedPrescription.id });

        if (!prescription.id) {
            currentId.value = savedPrescription.id;
            noteForm.value = { ...savedPrescription };

            // ✅ Usar activarModoAccion para persistir el estado de edición
            activarModoAccion('editar-receta', 'Editar Receta', {
                editingState: {
                    currentId: savedPrescription.id,
                    resourceType: 'receta'
                }
            });

            // Cargar datos en el formulario
            cargarDatosEnFormulario(savedPrescription, 'receta');
        }
    } catch (error) {
        console.error('❌ Error al guardar receta:', error.response?.data);
        if (error.response?.status === 422) {
            errors.value = error.response.data.errors || {};
            const errorCount = Object.keys(errors.value).length;
            const firstError = Object.values(errors.value)[0];
            const errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;

            proxy.$notify(
                `Error de validación: ${errorMessage}`,
                `Se encontraron ${errorCount} error(es) en el formulario`,
                "danger",
                "ni ni-fat-remove ni-lg"
            );
        } else {
            Swal.fire("Error", error.response?.data?.message || "Error al guardar receta", "error");
        }
    }
};

// Función para eliminar receta
const deletePrescription = async (prescription) => {
    try {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            html: `¡No podrás revertir esto!<br>¿Deseas eliminar esta receta?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Sí, eliminar!',
            customClass: {
                confirmButton: 'btn bg-gradient-success',
                cancelButton: 'btn bg-gradient-danger'
            },
            buttonsStyling: false
        });

        if (result.isConfirmed) {
            await api.delete(`/${resourceApiPrescriptions}/${prescription.id}`);
            Swal.fire('Eliminado!', 'La receta ha sido eliminada.', 'success');

            // Refrescar lista y resetear formulario
            await fetchPrescriptions();
            resetForm();
        }
    } catch (error) {
        Swal.fire('Error', 'Hubo un problema al eliminar la receta.', 'error');
    }
};

// ========== FUNCIONES PARA DOCUMENTOS ==========
// Función para guardar documento (similar a saveNote)
const saveDocument = async (document) => {
    try {
        if (!patientId.value) {
            Swal.fire("Error", "No se puede guardar el documento: paciente no identificado", "error");
            return;
        }

        document.patient_id = patientId.value;

        const response = document.id
            ? await api.put(`/${resourceApiDocuments}/${document.id}`, document)
            : await api.post(`/${resourceApiDocuments}`, document);

        const savedDocument = response.data.data;
        errors.value = {};

        proxy.$notify(response.data.message || "Documento guardado exitosamente", "", "success", "ni ni-like-2 ni-lg");

        // Refrescar la lista de documentos
        await fetchDocuments();

        // Actualizar timeline
        const currentPatientId = patientId.value;
        patientEventBus.notify(currentPatientId, { action: 'document-saved', documentId: savedDocument.id });

        if (!document.id) {
            currentId.value = savedDocument.id;
            noteForm.value = { ...savedDocument };

            // ✅ Usar activarModoAccion para persistir el estado de edición
            activarModoAccion('editar-documento', 'Editar Documento', {
                editingState: {
                    currentId: savedDocument.id,
                    resourceType: 'documento'
                }
            });

            // Cargar datos en el formulario
            cargarDatosEnFormulario(savedDocument, 'documento');
        }
    } catch (error) {
        console.error('❌ Error al guardar documento:', error.response?.data);
        if (error.response?.status === 422) {
            errors.value = error.response.data.errors || {};
            const errorCount = Object.keys(errors.value).length;
            const firstError = Object.values(errors.value)[0];
            const errorMessage = Array.isArray(firstError) ? firstError[0] : firstError;

            proxy.$notify(
                `Error de validación: ${errorMessage}`,
                `Se encontraron ${errorCount} error(es) en el formulario`,
                "danger",
                "ni ni-fat-remove ni-lg"
            );
        } else {
            Swal.fire("Error", error.response?.data?.message || "Error al guardar documento", "error");
        }
    }
};

// Función para eliminar documento
const deleteDocument = async (document) => {
    try {
        const result = await Swal.fire({
            title: '¿Estás seguro?',
            html: `¡No podrás revertir esto!<br>¿Deseas eliminar este documento?`,
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Sí, eliminar!',
            customClass: {
                confirmButton: 'btn bg-gradient-success',
                cancelButton: 'btn bg-gradient-danger'
            },
            buttonsStyling: false
        });

        if (result.isConfirmed) {
            await api.delete(`/${resourceApiDocuments}/${document.id}`);
            Swal.fire('Eliminado!', 'El documento ha sido eliminado.', 'success');

            // Refrescar lista y resetear formulario
            await fetchDocuments();
            resetForm();
        }
    } catch (error) {
        Swal.fire('Error', 'Hubo un problema al eliminar el documento.', 'error');
    }
};

// Función para seleccionar nota (para editar)
const selectNote = (noteOrId) => {
    if (!noteOrId) return;

    // Si recibe un número (ID), buscar la nota completa
    if (typeof noteOrId === 'number') {
        const foundNote = filteredNotes.value.find(n => n.id === noteOrId);
        if (foundNote) {
            currentId.value = foundNote.id;
            noteForm.value = { ...foundNote };
            errors.value = {};

            // ✅ Usar activarModoAccion para persistir
            activarModoAccion('editar-nota', 'Editar Nota', {
                editingState: {
                    currentId: foundNote.id,
                    resourceType: 'nota'
                }
            });
            cargarDatosEnFormulario(foundNote, 'nota-medica');
        }
    } else {
        // Si recibe un objeto, usarlo directamente
        currentId.value = noteOrId.id;
        noteForm.value = { ...noteOrId };
        errors.value = {};

        // ✅ Persistir también cuando se selecciona por objeto
        activarModoAccion('editar-nota', 'Editar Nota', {
            editingState: {
                currentId: noteOrId.id,
                resourceType: 'nota'
            }
        });
        cargarDatosEnFormulario(noteOrId, 'nota-medica');
    }
};

const selectPrescription = (prescriptionOrId) => {
    if (!prescriptionOrId) {
        console.warn('⚠️ selectPrescription recibió datos vacíos o null');
        return;
    }

    // Si recibe un número (ID), buscar la receta completa
    if (typeof prescriptionOrId === 'number') {
        const foundPrescription = filteredPrescriptions.value.find(p => p.id === prescriptionOrId);
        if (foundPrescription) {
            currentId.value = foundPrescription.id;
            noteForm.value = { ...foundPrescription };
            errors.value = {};

            // ✅ Usar activarModoAccion para persistir
            activarModoAccion('editar-receta', 'Editar Receta', {
                editingState: {
                    currentId: foundPrescription.id,
                    resourceType: 'receta'
                }
            });
            cargarDatosEnFormulario(foundPrescription, 'receta');
        }
    } else {
        // Si recibe un objeto, usarlo directamente
        currentId.value = prescriptionOrId.id;
        noteForm.value = { ...prescriptionOrId };
        errors.value = {};

        // ✅ Persistir también cuando se selecciona por objeto
        activarModoAccion('editar-receta', 'Editar Receta', {
            editingState: {
                currentId: prescriptionOrId.id,
                resourceType: 'receta'
            }
        });
        cargarDatosEnFormulario(prescriptionOrId, 'receta');
    }
};

const selectDocument = (documentOrId) => {
    if (!documentOrId) {
        console.warn('⚠️ selectDocument recibió datos vacíos o null');
        return;
    }

    // Si recibe un número (ID), buscar el documento completo
    if (typeof documentOrId === 'number') {
        const foundDocument = filteredDocuments.value.find(d => d.id === documentOrId);
        if (foundDocument) {
            currentId.value = foundDocument.id;
            noteForm.value = { ...foundDocument };
            errors.value = {};

            // ✅ Usar activarModoAccion para persistir
            activarModoAccion('editar-documento', 'Editar Documento', {
                editingState: {
                    currentId: foundDocument.id,
                    resourceType: 'documento'
                }
            });
            cargarDatosEnFormulario(foundDocument, 'documento');
        }
    } else {
        // Si recibe un objeto, usarlo directamente
        currentId.value = documentOrId.id;
        noteForm.value = { ...documentOrId };
        errors.value = {};

        // ✅ Persistir también cuando se selecciona por objeto
        activarModoAccion('editar-documento', 'Editar Documento', {
            editingState: {
                currentId: documentOrId.id,
                resourceType: 'documento'
            }
        });
        cargarDatosEnFormulario(documentOrId, 'documento');
    }
};

// Función para resetear formulario
const resetForm = () => {
    currentId.value = 0;
    errors.value = {};
    noteForm.value = {
        created: new Date().toISOString().split('T')[0],
        reason_for_visit: '',
        soap: '',
        physical_examination: '',
        laboratory_and_studies: '',
        diagnoses_clinical_problems: '',
        physical_examination_json: '{}',
        diagnosis_cie10_1: '',
        diagnosis_cie10_2: '',
        diagnosis_cie10_3: '',
    };
};

// Función para alternar modo de edición
const toggleEditMode = async () => {
    if (isEditing.value) {
        // Guardar cambios
        await guardarCambios();
        // NO hacer toggle aquí porque guardarCambios ya pone isEditing = false
    } else {
        // Entrar en modo edición
        cargarDatosParaEdicion();
        isEditing.value = true;
    }
};


// Función para cancelar la edición
const cancelarEdicion = () => {
    // Simplemente salir del modo edición sin guardar
    isEditing.value = false;
};


// Cargar datos del perfil para edición
const cargarDatosParaEdicion = () => {
    perfilEditado.value = {
        // Datos básicos del paciente
        first_name: datosPaciente.value.first_name || '',
        last_name: datosPaciente.value.last_name || '',
        gender: datosPaciente.value.gender || '',
        birthdate: datosPaciente.value.birthdate || '',
        email: datosPaciente.value.email || '',
        whatsapp: datosPaciente.value.whatsapp || '',
        // Datos del perfil extendido
        address: perfilPaciente.value.address || '',
        reference: perfilPaciente.value.reference || '',
        responsible_family_member: perfilPaciente.value.responsible_family_member || '',
        family_member_relationship: perfilPaciente.value.family_member_relationship || '',
        emergency_contact: perfilPaciente.value.emergency_contact || '',
        patient_identification: perfilPaciente.value.patient_identification || '',
        internal_comments: perfilPaciente.value.internal_comments || '',
        patient_feedback: perfilPaciente.value.patient_feedback || ''
    };
};
// Función para mapear género de M/F/O a male/female/other
const mapearGenero = (valor) => {
    const mapa = { "M": "male", "F": "female", "O": "other" };
    return mapa[valor] || valor;
};


// Función para guardar cambios del perfil
const guardarCambios = async () => {
    // Validación: email válido si viene informado
    emailTocado.value = true;
    onEmailInput();
    if (perfilEditado.value?.email && emailInvalido.value) {
        proxy?.$notify?.(
            'Correo electrónico inválido',
            'Por favor, ingresa un email con formato válido (ej. usuario@dominio.com).',
            'danger',
            'ni ni-fat-remove ni-lg'
        );
        return;
    }
    if (!patientId.value) {
        return;
    }

    // Datos básicos del paciente
    const datosBasicos = {
        first_name: perfilEditado.value.first_name,
        last_name: perfilEditado.value.last_name,
        gender: mapearGenero(perfilEditado.value.gender),
        birthdate: perfilEditado.value.birthdate,
        email: perfilEditado.value.email,
        whatsapp: perfilEditado.value.whatsapp
    };

    // Datos del perfil extendido
    const perfilExtendido = {
        profile: {
            address: perfilEditado.value.address,
            reference: perfilEditado.value.reference,
            responsible_family_member: perfilEditado.value.responsible_family_member,
            family_member_relationship: perfilEditado.value.family_member_relationship,
            emergency_contact: perfilEditado.value.emergency_contact,
            patient_identification: perfilEditado.value.patient_identification,
            internal_comments: perfilEditado.value.internal_comments,
            patient_feedback: perfilEditado.value.patient_feedback
        }
    };

    try {
        // Actualizar datos básicos del paciente
        await api.put(`/pacientes/${patientId.value}`, datosBasicos);

        // Actualizar perfil extendido del paciente
        await api.put(`/pacientes/${patientId.value}/profile`, perfilExtendido);

        const fechaActualizacion = new Date();

        // Preparar datos actualizados completos
        const datosActualizados = {
            ...datosBasicos,
            profile: {
                ...datosPaciente.value.profile,
                ...perfilExtendido.profile,
                updated_at: fechaActualizacion
            }
        };

        // Prevenir actualizaciones recursivas
        if (isUpdatingFromEventBus.value) {
            return;
        }

        // Solo notificar una vez a través del Event Bus
        updatePatientData({ id: patientId.value, ...datosActualizados });

        // Guardar en localStorage
        const { addPatientData } = usePacientesStore();
        addPatientData(datosActualizados);

        // Actualizar datosPaciente directamente para que la vista refleje los cambios
        Object.assign(datosPaciente.value, datosActualizados);

        // Salir del modo edición
        isEditing.value = false;
        await nextTick();


        // Mostrar notificación de éxito
        proxy.$notify(
            datosPaciente.value.first_name + " " + datosPaciente.value.last_name,
            "Perfil del paciente actualizado correctamente",
            "success",
            "ni ni-like-2 ni-lg"
        );


    } catch (error) {

        // Mostrar mensaje de error (opcional)
        // Aquí podrías agregar una notificación de error
    }
};

// Función para cerrar panel
const cerrarPanel = () => {
    // Si está en modo edición, cancelar edición
    if (isEditing.value) {
        isEditing.value = false;
    }

    emit('cerrar');
    cerrarDetalle(); // También actualizar el estado global
    cerrarModoAccion(); // Cerrar el modo de acción si está activo
};

// Función para manejar errores del gestor de documentos
const handleDocumentError = (error) => {
    console.error('Error en gestor de documentos:', error);
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'Error al gestionar documentos',
        confirmButtonColor: '#d33'
    });
};

const handlePatientUpdate = (updatedData = {}) => {
    if (updatedData.action === 'patient-photo-updated') {
        datosPaciente.value = {
            ...datosPaciente.value,
            photo_url: updatedData.photo_url
        };
        return;
    }

    if (updatedData.action === 'patient-photo-deleted') {
        datosPaciente.value = {
            ...datosPaciente.value,
            photo_url: null
        };
        return;
    }

    if (isUpdatingFromEventBus.value) {
        return;
    }

    isUpdatingFromEventBus.value = true;

    try {
        if (datosPaciente.value && updatedData.id === datosPaciente.value.id) {
            datosPaciente.value = {
                ...datosPaciente.value,
                ...updatedData
            };
        }

        if (isEditing.value) {
            Object.keys(updatedData).forEach(key => {
                if (Object.prototype.hasOwnProperty.call(perfilEditado.value, key)) {
                    perfilEditado.value[key] = updatedData[key];
                }
            });
        }
    } finally {
        setTimeout(() => {
            isUpdatingFromEventBus.value = false;
        }, 100);
    }
};

// Inicializar datos cuando se monte el componente
onMounted(async () => {
    if (modoAccion.value === 'perfil-paciente') {
        // Primero cargar datos desde el store
        cargarPacienteDesdeStore();
        cargarDatosParaEdicion();
    }

    // Suscribirse al Event Bus si hay un paciente activo
    if (patientId.value) {
        eventBusUnsubscribe = patientEventBus.subscribe(patientId.value, handlePatientUpdate);
    }

    // Escuchar evento de cierre del FilesManager
    window.addEventListener('close-files-manager', cerrarPanel);

    // Cargar notas cuando la vista sea nueva nota o editar nota
    const modoInicial = modoAccion.value;

    if (modoInicial === 'nueva-nota') {
        await fetchNotes();
        resetForm();
        currentId.value = 0;
    } else if (modoInicial === 'editar-nota' && datosEdicion.value?.id) {
        await fetchNotes();
        const noteId = datosEdicion.value.id;
        const foundNote = filteredNotes.value.find(n => n.id === noteId);
        if (foundNote) {
            selectNote(foundNote);
        }
    } else if (modoInicial === 'editar-receta' && datosEdicion.value?.id) {
        await fetchPrescriptions();
        const prescriptionId = datosEdicion.value.id;
        const foundPrescription = filteredPrescriptions.value.find(p => p.id === prescriptionId);
        if (foundPrescription) {
            selectPrescription(foundPrescription);
        }
    } else if (modoInicial === 'editar-documento' && datosEdicion.value?.id) {
        await fetchDocuments();
        const documentId = datosEdicion.value.id;
        const foundDocument = filteredDocuments.value.find(d => d.id === documentId);
        if (foundDocument) {
            selectDocument(foundDocument);
        }
    }
});

// Watcher ÚNICO optimizado para evitar conflictos
watch([modoAccion, patientId], async ([nuevoModo, newPatientId], [prevModo, oldPatientId]) => {
    // Manejar cambio de modo O cambio de paciente
    if (nuevoModo !== prevModo || newPatientId !== oldPatientId) {
        if (nuevoModo === 'perfil-paciente') {
            cargarPacienteDesdeStore();
            cargarDatosParaEdicion();
        } else if (nuevoModo === 'nueva-nota') {
            await fetchNotes();
            resetForm(); // Limpiar formulario para nueva nota
            currentId.value = 0; // Resetear para modo crear
        } else if (nuevoModo === 'nueva-receta') {
            resetForm(); // Limpiar formulario para nueva receta
            currentId.value = 0; // Resetear para modo crear
        } else if (nuevoModo === 'nuevo-reporte') {
            resetForm(); // Limpiar formulario para nuevo documento
            currentId.value = 0; // Resetear para modo crear
        } else if (nuevoModo === 'editar-nota') {
            if (datosEdicion.value?.id) {
                // Cargar notas y establecer ID para edición
                await fetchNotes();
                const noteId = datosEdicion.value.id;
                const foundNote = filteredNotes.value.find(n => n.id === noteId);
                if (foundNote) {
                    selectNote(foundNote);
                }
            } else {
                resetForm();
            }
        } else if (nuevoModo === 'editar-receta') {
            if (datosEdicion.value?.id) {
                // Cargar recetas y establecer ID para edición
                await fetchPrescriptions();
                const prescriptionId = datosEdicion.value.id;
                const foundPrescription = filteredPrescriptions.value.find(p => p.id === prescriptionId);
                if (foundPrescription) {
                    selectPrescription(foundPrescription);
                }
            } else {
                resetForm();
            }
        } else if (nuevoModo === 'editar-documento') {
            if (datosEdicion.value?.id) {
                // Cargar documentos y establecer ID para edición
                await fetchDocuments();
                const documentId = datosEdicion.value.id;
                const foundDocument = filteredDocuments.value.find(d => d.id === documentId);
                if (foundDocument) {
                    selectDocument(foundDocument);
                }
            } else {
                resetForm();
            }
        } else if (nuevoModo === 'signos-vitales') {
            // Cargar datos de signos vitales para las gráficas
            fetchVitalSigns();
        }
    }

    // Manejar cambio de paciente
    if (newPatientId !== oldPatientId) {
        // Desuscribirse del paciente anterior
        if (eventBusUnsubscribe) {
            eventBusUnsubscribe();
            eventBusUnsubscribe = null;
        }

        // Suscribirse al nuevo paciente
        if (newPatientId) {
            eventBusUnsubscribe = patientEventBus.subscribe(newPatientId, handlePatientUpdate);
        }

        // Si estamos en modo signos-vitales, recargar los datos del nuevo paciente
        if (nuevoModo === 'signos-vitales') {
            fetchVitalSigns();
        }
    }
}, {
    immediate: false,
    flush: 'post' // Ejecutar después del renderizado para evitar conflictos
});

// Watcher adicional para datosEdicion - se activa cuando se cargan datos de edición
watch(() => datosEdicion.value, (nuevosDatos) => {
    if (!nuevosDatos || !nuevosDatos.datos) return;

    // 🛡️ Evitar cargar datos incompletos (solo ID) que vienen de la restauración
    // Dejar que el watcher principal o onMounted manejen la carga completa desde la API
    if (Object.keys(nuevosDatos.datos).length <= 1 && nuevosDatos.datos.id) {
        return;
    }

    // 🛡️ Evitar bucles infinitos: si ya estamos editando este ID, no hacer nada
    if (currentId.value === nuevosDatos.id) {
        return;
    }

    // Cargar datos según el modo actual
    if (modoAccion.value === 'editar-receta') {
        nextTick(() => {
            selectPrescription(nuevosDatos.datos);
        });
    } else if (modoAccion.value === 'editar-documento') {
        nextTick(() => {
            selectDocument(nuevosDatos.datos);
        });
    } else if (modoAccion.value === 'editar-nota') {
        nextTick(() => {
            selectNote(nuevosDatos.datos);
        });
    }
}, { deep: true });

// Limpiar suscripción al desmontar
onUnmounted(() => {
    if (eventBusUnsubscribe) {
        eventBusUnsubscribe();
    }
    // Limpiar el listener del FilesManager
    window.removeEventListener('close-files-manager', cerrarPanel);
});

</script>

<style scoped>
/* ================================
   DISEÑO PROFESIONAL EJECUTIVO
   Paleta: Navy Blue, Pearl White, Gold
   ================================ */

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

/* Panel Principal - Diseño Ejecutivo */
.panel-detalle {
    background: linear-gradient(180deg, #f8f9fc 0%, #ffffff 100%);
    border-radius: 0;
    border-left: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: -8px 0 32px rgba(15, 23, 42, 0.12);
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    transform: translateX(100%);
    opacity: 0;
    position: relative;
    overflow: hidden;
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.panel-detalle::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background: linear-gradient(180deg, #1e40af 0%, #3b82f6 50%, #60a5fa 100%);
    opacity: 0.8;
}

.panel-detalle.visible {
    transform: translateX(0);
    opacity: 1;
}

.panel-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
}

/* Header Ejecutivo - Sticky/Fixed al hacer scroll */
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    border-bottom: 1px solid rgba(15, 23, 42, 0.08);
    backdrop-filter: blur(20px);
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);
    transition: box-shadow 0.3s ease;
}

/* Sombra más pronunciada al hacer scroll */
.panel-content:not(:first-child) .panel-header,
.panel-header:hover {
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.12);
}

.panel-header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent 0%, #1e40af 50%, transparent 100%);
    opacity: 0.2;
}

.panel-header h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    letter-spacing: -0.3px;
}

.panel-header h3 i {
    color: #1e40af;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, rgba(30, 64, 175, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
    border-radius: 10px;
    border: 1px solid rgba(30, 64, 175, 0.2);
}

/* Icono Header Simple - Sin Fondo de Botón */
.panel-header h3 i.icono-header-simple {
    width: auto;
    height: auto;
    background: none;
    border: none;
    border-radius: 0;
    color: #1e40af;
    font-size: 1.5rem;
    margin-right: 0.5rem;
}

.header-buttons {
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

/* Botones Argon - Ajustes para el Header */
.header-buttons .btn {
    margin: 0 0.25rem;
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
}

.header-buttons .btn i {
    font-size: 0.875rem;
}

.cerrar-btn {
    background: #ffffff;
    border: 1px solid rgba(239, 68, 68, 0.25);
    width: 36px;
    height: 36px;
    border-radius: 8px;
    font-size: 1.25rem;
    cursor: pointer;
    color: #dc2626;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 2px 8px rgba(220, 38, 38, 0.1);
}

.cerrar-btn:hover {
    background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
    color: #ffffff;
    border-color: transparent;
    transform: translateY(-2px) rotate(90deg);
    box-shadow: 0 4px 16px rgba(220, 38, 38, 0.35);
}

/* Panel Body - Compacto y Formal */
.panel-body {
    padding: 1.5rem 2rem 2rem;
    overflow: visible;
    flex-grow: 0;
    background: #ffffff;
}

/* Panel Body para documentos - sin padding para que FilesManager tenga control total */
.panel-body.documentos-panel {
    padding: 0;
    overflow: visible;
}

/* Panel Body sin header - para formularios con header propio */
.panel-body.no-header {
    padding: 0;
    margin: 0;
    height: 100%;
}

/* Panel Body para grids - altura completa sin padding */
.panel-body.full-height {
    padding: 0;
    margin: 0;
    height: calc(100% - 70px);
    /* Altura total menos el header */
    overflow: hidden;
}

/* Eliminar estilos de card en formularios dentro de no-header */
.panel-body.no-header :deep(.modern-form-container) {
    margin-bottom: 0;
    border-radius: 0;
    box-shadow: none;
    border: none;
}

.panel-body.no-header :deep(.form-header) {
    border-radius: 0;
}

/* Scrollbar Profesional - Azul */
.panel-content::-webkit-scrollbar {
    width: 12px;
}

.panel-content::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-left: 1px solid rgba(15, 23, 42, 0.05);
}

.panel-content::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #1e40af 0%, #3b82f6 100%);
    border-radius: 6px;
    border: 3px solid #f1f5f9;
}

.panel-content::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #1e3a8a 0%, #2563eb 100%);
}

/* Panel Vacío - Estado Inicial */
.panel-vacio {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: center;
    color: #64748b;
    padding: 4rem 2.5rem;
}

.panel-vacio i {
    font-size: 5rem;
    margin-bottom: 2rem;
    color: #1e40af;
    opacity: 0.15;
    animation: pulse-elegant 3s ease-in-out infinite;
}

@keyframes pulse-elegant {

    0%,
    100% {
        opacity: 0.15;
        transform: scale(1);
    }

    50% {
        opacity: 0.25;
        transform: scale(1.03);
    }
}

.panel-vacio p {
    max-width: 320px;
    line-height: 1.75;
    font-size: 1rem;
    font-weight: 400;
    color: #475569;
}

.detalle-form {
    margin-top: 2rem;
    border-top: 2px dashed rgba(102, 126, 234, 0.15);
    padding-top: 1.75rem;
}

.detalle-form button {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 0.875rem 1.75rem;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 700;
    font-size: 0.95rem;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.detalle-form button:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(102, 126, 234, 0.45);
}

.detalle-form button:active {
    transform: translateY(-1px);
}

/* Estilos para los nuevos formularios */
.descripcion-modo {
    color: #8492a6;
    margin-bottom: 1.75rem;
    font-size: 0.95rem;
    line-height: 1.6;
    padding: 1rem;
    background: rgba(102, 126, 234, 0.04);
    border-left: 4px solid #667eea;
    border-radius: 8px;
}

.historial-placeholder,
.grafico-placeholder {
    text-align: center;
    padding: 4rem 2rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.03) 0%, rgba(118, 75, 162, 0.03) 100%);
    border-radius: 16px;
    color: #8492a6;
    border: 2px dashed rgba(102, 126, 234, 0.15);
}

.historial-placeholder i,
.grafico-placeholder i {
    color: #667eea;
    opacity: 0.4;
    margin-bottom: 1.5rem;
    animation: float 3s ease-in-out infinite;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

/* ================================
   ESTADOS VACÍOS Y DE CARGA
   ================================ */

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
}

.empty-state i {
    color: #cbd5e1;
    margin-bottom: 20px;
}

.empty-state h4 {
    font-size: 18px;
    font-weight: 600;
    color: #334155;
    margin: 0 0 12px 0;
}

.empty-state p {
    font-size: 14px;
    color: #64748b;
    margin: 0;
}

/* Contenedor del Perfil - Header */
.perfil-container {
    display: flex;
    align-items: flex-start;
    gap: 2rem;
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #e2e8f0;
}

/* Información del Perfil */
.perfil-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

/* Campos de formulario */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

/* Etiqueta - Compacta y Formal */
.form-group label {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #64748b;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    gap: 0.35rem;
}

/* Iconos - Azul Profesional */
.form-group label i {
    font-size: 0.75rem;
    width: 0.85rem;
    text-align: center;
    color: #1e40af;
}
</style>
